
// src/web/components/emoji-palette.jsx

import React from 'react'
import ui from '../../helpers/ui-state'
import { translate } from 'react-i18next'
import { PropTypes } from 'prop-types'
import _ from 'lodash'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  Layout,
  Panel,
} from 'react-toolbox/lib/layout'
import {
  Button,
} from 'react-toolbox/lib/button'
import ScrollableDialogPanel from './scrollable-dialog-panel.jsx'
import emojiPaletteChars from '../../helpers/emoji-palette-chars'
import theme from './themes/action-dialog.css'
import emoji from '../../native/assets/emoji'

class EmojiPaletteProvider extends React.Component {
  static childContextTypes = {
    showEmojiPalette: PropTypes.func,
  }

  onClose = ()=> this.props.updateUI({ active: false })
  onSelect = (event)=> {
    const shortname = event.currentTarget.attributes['data-shortname'].value
    const unicode = event.currentTarget.attributes['data-unicode'].value
    this.props.ui.callback && this.props.ui.callback(shortname, unicode)
    this.props.updateUI({ active: false })
  }

  getChildContext() {
    return {
      showEmojiPalette: (callback)=> {
        this.props.updateUI({ active: true, callback })
      }
    }
  }

  render() {
    const {
      t,
      ui,
      children,
      updateUI,
    } = this.props

    return (
      <div>
        <Dialog active={ui.active} theme={theme}
            title={t('label:絵文字を入力')}
            actions={[{ label: t('label:取り消し'), onClick: this.onClose }]}
            onOverlayClick={this.onClose}
            onEscKeyDown={this.onClose} >
          <ScrollableDialogPanel>
            {emojiPaletteChars.map((char)=> 
              <img onClick={this.onSelect} key={char.unicode}
                src={emoji[char.unicode]}
                data-unicode={char.unicode}
                data-shortname={char.shortname}
                width="24px" height="24px"
                style={{ margin: '2px', cursor: 'pointer' }} />
            )}
          </ScrollableDialogPanel>
        </Dialog>
        {children}
      </div>
    )
  }
}

export default translate()(ui({ state: { active: false, callback: undefined }})(EmojiPaletteProvider))



// WEBPACK FOOTER //
// ./src/web/components/emoji-palette.jsx